import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectWorksheet } from 'services/worksheet/selectors';
import { WORKSHEET_TYPE_WEED_SPRAY } from 'services/worksheet/constants';
import get from 'lodash.get';

const selectSprayWorksheetPages = createDeepEqualSelector(
    selectWorksheet,
    (sprayWorksheetState) => get(sprayWorksheetState, ['pages'])
);

const makeSelectSprayWorksheetPages = (): typeof selectSprayWorksheetPages =>
    selectSprayWorksheetPages;

const selectIsWeedSprayWorksheet = createDeepEqualSelector(
    selectWorksheet,
    (sprayWorksheetState) =>
        get(sprayWorksheetState, 'type') === WORKSHEET_TYPE_WEED_SPRAY
);

export { makeSelectSprayWorksheetPages, selectIsWeedSprayWorksheet };
